import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MAT_MOMENT_DATE_ADAPTER_OPTIONS, MomentDateAdapter } from '@angular/material-moment-adapter';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { DatePickerSettings } from './models';
import { DateRange } from '@emi/shared/models';

const DATE_PICKER_FORMATS = {
    parse: {
        dateInput: 'LL',
    },
    display: {
        dateInput: 'DD MMM YYYY',
        monthYearLabel: 'MMM YYYY',
        dateA11yLabel: 'LL',
        monthYearA11yLabel: 'YYYY',
    },
};

@Component({
    selector: 'via-date-range',
    templateUrl: './date-range.component.html',
    styleUrls: ['./date-range.component.scss'],
    providers: [
        {
            provide: DateAdapter,
            useClass: MomentDateAdapter,
            deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS],
        },
        { provide: MAT_DATE_FORMATS, useValue: DATE_PICKER_FORMATS },
    ],
})
export class DateRangeComponent implements OnInit {

    @Input()
    public datePickerSettings: DatePickerSettings;

    @Output()
    public onDateRangeChange = new EventEmitter<DateRange>();

    public dateRange = new FormGroup({
        startDate: new FormControl(),
        endDate: new FormControl(),
    });

    public date = new FormControl(new Date());
    public serializedDate = new FormControl(new Date().toISOString());

    constructor(private dateAdapter: DateAdapter<Date>) {
        this.dateAdapter.setLocale('en-GB');
    }

    public ngOnInit() {
        this.dateRange.controls.startDate.setValue(this.datePickerSettings.dateRange.startDate);
        this.dateRange.controls.endDate.setValue(this.datePickerSettings.dateRange.endDate);
    }

    public handleDateRangeChange = () => {
        this.onDateRangeChange.emit(new DateRange(this.dateRange.controls.startDate.value, this.dateRange.controls.endDate.value));
    };
}
